import React, { useState } from 'react';
import Gallery from '../components/Gallery';
import site from '../content/siteContent';

export default function Portfolio() {
  const [filter, setFilter] = useState('All');

  // Define categories based on services
  const categories = [
    'All',
    'Modular Kitchens',
    'Wardrobes & Storage',
    'False Ceilings',
    'Wall Panelling',
    'TV Units',
    'Office Interiors',
  ];

  // Get filtered items
  const items =
    filter === 'All' ? site.projects : site.projects.filter((i) => i.category === filter);

  return (
    <div className="min-h-screen bg-sand/5">
      {/* Hero Section */}
      <div className="bg-wood text-sand py-16">
        <div className="container">
          <h1 className="text-4xl font-bold mb-4">Our Portfolio</h1>
          <p className="text-sand/90 max-w-2xl text-content">
            Explore our completed projects across various interior categories. Each project
            showcases our commitment to quality, innovation, and customer satisfaction.
          </p>
        </div>
      </div>

      <div className="container py-12">
        {/* Filter Tabs */}
        <div className="flex flex-wrap gap-2 mb-8">
          {categories.map((cat) => (
            <button
              key={cat}
              onClick={() => setFilter(cat)}
              className={`px-4 py-2 rounded-lg transition-all duration-300 ${
                filter === cat
                  ? 'bg-wood text-sand shadow-lg scale-105'
                  : 'bg-white hover:bg-wood/10'
              }`}
            >
              {cat}
            </button>
          ))}
        </div>

        {/* Stats */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8">
          {[
            { label: 'Projects Completed', value: site.projects.length },
            { label: 'Happy Clients', value: '50+' },
            { label: 'Years Experience', value: '20+' },
            { label: 'Cities Served', value: '10+' },
          ].map((stat, idx) => (
            <div key={idx} className="card p-4 text-center">
              <div className="text-2xl font-bold text-wood">{stat.value}</div>
              <div className="text-sm text-neutralText">{stat.label}</div>
            </div>
          ))}
        </div>

        {/* Gallery Grid */}
        <div className="mt-8">
          <Gallery items={items} />
        </div>

        {/* CTA Section */}
        <div className="mt-12 text-center">
          <div className="card p-8 bg-wood/5">
            <h3 className="text-2xl font-bold mb-4">Have a Project in Mind?</h3>
            <p className="text-neutralText mb-6 max-w-2xl mx-auto">
              Whether it's a modern kitchen, elegant wardrobe, or complete office interior, we're
              here to bring your vision to life.
            </p>
            <a href="/contact" className="btn btn-wood">
              Start Your Project
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
